import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import WorkGalleryLayer from "../components/WorkGalleryLayer";

const WorkGalleryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Work Gallery List' />

        {/* AddWorkgalleryLayer */}
        <WorkGalleryLayer />
      </MasterLayout>
    </>
  );
};

export default WorkGalleryPage;
